import React from "react";
import { Link } from "react-router-dom";

const ToolsPage = () => {
  return (
    <section className="subpage-section">
      <div className="container">
        <h1 className="subpage-title">Supplemental Tools</h1>
        <p className="subpage-body">
          Supplemental tools include the workflows teams need after basecalling:
          data sharing, collaboration, quality control, and downstream review.
        </p>
        <div className="subpage-visual">
          <div className="subpage-visual-media">
            Placeholder image: shared workspace with comments, QC, and export
          </div>
          <div className="subpage-visual-notes">
            <h2>What is most useful on this page</h2>
            <ul>
              <li>
                One screenshot of team collaboration and comments in context.
              </li>
              <li>One QC dashboard panel that shows pass/fail confidence.</li>
              <li>
                One export/share flow showing reduced operational friction.
              </li>
            </ul>
          </div>
        </div>
        <div className="subpage-feature-grid">
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: secure sharing controls
            </div>
            <h3>Data Sharing</h3>
            <p>
              Share datasets, results, and run outputs across teams without
              relying on ad hoc file transfers.
            </p>
            <Link to="/resources#guides" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: collaborative annotation thread
            </div>
            <h3>Collaboration Workflows</h3>
            <p>
              Keep analysts and researchers aligned with a centralized workspace
              for annotation and review.
            </p>
            <Link to="/resources#quickstart" className="read-more-link">
              Read more
            </Link>
          </div>
          <div className="subpage-feature-card">
            <div className="subpage-card-image-placeholder">
              Placeholder: QC metrics and interactive charts
            </div>
            <h3>QC and Visualization</h3>
            <p>
              Validate outputs with quality metrics and interactive visual
              exploration before final interpretation.
            </p>
            <Link to="/resources#support" className="read-more-link">
              Read more
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolsPage;
